import { Card, CardContent } from "~/components/ui/card";
import { Building2, Star, MapPin, Globe } from "lucide-react";
import Container from "~/components/atoms/Container";
import { getCountrySpecificMeta, HOME_PAGE_SECTION_IDS } from "./constants";

export const AboutSection = ({ mobile, region, country }: { mobile?: boolean; region: string; country: string }) => {
  const data = getCountrySpecificMeta(region);

  let aboutUs = "";
  if (!data?.aboutUs) {
    aboutUs = `At Office Hub ${country}, we connect professionals and businesses with flexible office spaces across the ${country}.
      From coworking hubs and serviced offices to private suites and enterprise spaces,<br><br> we make it simple to find the right workspace for your team.
      Our goal is to make office leasing stress-free.<br><br> All listings are verified, pricing is transparent, and most spaces offer short, flexible terms that grow with your business.<br>
      Reach out to our expert team today to explore premium office spaces in major business cities across the ${country}`
  } else {
    aboutUs = data?.aboutUs;
  }


  return (
    <section id={HOME_PAGE_SECTION_IDS.about} className="bg-gray-100 px-4 md:px-0 py-8 scroll-mt-28">
      <Container htmlFor="ultra-wide">
        {/* Mobile heading */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-5 xl:gap-20">
          {/* Mobile heading */}
          <div className="lg:col-span-2 space-y-5">
            <p className="text-[64px] max-w-[315px] text-start font-bold text-gray-800 leading-tight">
              About Office Hub
            </p>
            <h2 className="text-xl max-w-[400px] px-2 md:px-0 text-start font-semibold text-gray-800 leading-8">
              Office Hub is your ultimate partner in revolutionizing the way you work.
            </h2><div className="text-xl">
              <p
                className="text-gray-800 text-xl leading-7"
                dangerouslySetInnerHTML={{ __html: aboutUs }}
              />
            </div>
          </div>

          <div className="p-4 md:p-5 space-y-2 md:space-y-5 rounded-lg bg-white shadow-custom max-width-[400px]">

            <p className="text-xl font-semibold text-oh-black">
              Message from the Founder
            </p>
            <p className="text-base text-gray-800 leading-7">
              “At Office Hub, our mission is simple — to make finding and managing workspaces effortless. We’re here to connect people, places, and possibilities through innovation, transparency, and trust. Every partnership we build helps shape the future of how the world works.”
            </p>
            <div className="flex flex-col space-y-3 md:space-y-5">
              <img
                src={`https://ik.imagekit.io/officehub/tr:h-400,f-avif/${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/meet-the-team/grant-ceo.avif`}
                alt="Grant Philipp, Office Hub Founder, in a premium private office, representing the professional standard of the global workspace network"
                title="Grant Philipp"
                width={302}
                height={302}
                className="w-full mx-auto md:mx-0 md:w-[302px] rounded-md object-cover"
                loading="lazy"
              />
              <div className="text-start">
                <p className="text-2xl font-semibold text-oh-black">Grant Philipp</p>
                <p className="text-xs text-oh-black font-semibold">CEO and Founder</p>
              </div>
            </div>

          </div>
          <div className="grid grid-cols-2 lg:grid-cols-1 gap-3 md:gap-3">
            <Card className="py-3 px-2 text-center shadow-custom max-w-[300px]">
              <CardContent className="flex flex-col items-center space-y-1">
                <Building2 className="h-7 w-7 text-cyan-500" />
                <p className="text-3xl md:text-4xl font-semibold text-gray-700">
                  400%
                </p>
                <h3 className="text-sm md:text-base text-gray-900">
                  Faster than average office search
                </h3>
              </CardContent>
            </Card>

            <Card className="py-3 px-2 text-center shadow-custom max-w-[300px]">
              <CardContent className="flex flex-col items-center space-y-1">
                <Star className="h-8 w-8 text-cyan-500" />
                <p className="text-3xl md:text-4xl font-semibold text-gray-700">
                  4.9/5
                </p>
                <h3 className="text-sm md:text-base text-gray-900">
                  Google star rating
                </h3>
              </CardContent>
            </Card>

            <Card className="py-3 px-2 text-center shadow-custom max-w-[300px]">
              <CardContent className="flex flex-col items-center space-y-1">
                <MapPin className="h-8 w-8 text-cyan-500" />
                <p className="text-3xl md:text-4xl font-semibold text-gray-700">
                  100%
                </p>
                <h3 className="text-sm md:text-base text-gray-900">
                  Market Coverage
                </h3>
              </CardContent>
            </Card>

            <Card className="py-3 px-2 text-center shadow-custom max-w-[300px]">
              <CardContent className="flex flex-col items-center space-y-1">
                <Globe className="h-8 w-8 text-cyan-500" />
                <p className="text-3xl md:text-4xl font-semibold text-gray-700">
                  110+
                </p>
                <h3 className="text-sm md:text-base text-gray-900">
                  Countries Covered
                </h3>
              </CardContent>
            </Card>
          </div>
        </div>
      </Container>
    </section>
  );
};